import React, { Component } from 'react';
import _ from 'lodash';

import { Menu, Row, Col } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import { withAppContext } from '../store/contextStore';

class SideMenu extends Component {
  onLogout=() => {
    this.props.context.dropUser();
    this.props.history.push('/login');
  };
  render() {
    const role = _.get(this.props.context.state.userDetails, 'userProfile');
    return (
      <Row className='fullheight sideMenuDiv' style={{minHeight:'85vh'}}>
        <Col span={ 24 } className='fullheight' >
          <div className='fullheight'>
            { role === 'S' &&
            <Menu
              mode='inline'
              defaultSelectedKeys={ ['1'] }
              defaultOpenKeys={ ['sub1'] }
              style={ { height: '100%' } }
            >
              <Menu.Item key='1'>
                <NavLink to='/app/oraganizations'>
                  <i className='fa fa-sitemap font-icon-space fa-sm' aria-hidden='true' >&nbsp;
                  Oraganizations</i>
                </NavLink>
              </Menu.Item>
              <Menu.Item key='12' onClick={ this.onLogout }>
              <i className='fa fa-sign-out font-icon-space fa-sm' aria-hidden='true' >&nbsp;
              Logout</i></Menu.Item>
            </Menu>
          }
          </div>
        </Col>
      </Row>
    );
  }
}

export default withRouter(withAppContext(SideMenu));
